import store from '../../../store/store';
import { asyncHandler } from '../async-handler';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import { SAVE_CUSTOM_PROMPT_FROM_CHAT_API } from '../../constants/central-api';

export default async function save_custom_prompt_from_chat_api_call(
  conversationId: string,
  responseId: string,
  prompt: string
) {
  try {
    const accessToken = store.getState().auth.authorization.accessToken;
    const sellerToken = accessToken?.sellerToken;

    const requestInfo: RequestInfo = {
      url: SAVE_CUSTOM_PROMPT_FROM_CHAT_API,
      method: 'POST',
      body: JSON.stringify({
        conversation_id: conversationId,
        response_id: responseId,
        prompt: prompt,
      }),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: accessToken.type + ' ' + sellerToken,
      },
    };

    const actionType = 'SAVE_CUSTOM_PROMPT_FROM_CHAT';
    const customMsg = 'Custom prompt saved from chat successfully';

    const res: any = await asyncHandler(
      requestInfo,
      actionType,
      customMsg,
      false
    );

    const response = res?.data;

    if (res?.actionType === actionType && response?.success === true) {
      return { success: true, data: response.data || null, message: null };
    } else {
      return {
        success: false,
        error: response?.message || 'Failed to save prompt',
        message: response?.message || null,
      };
    }
  } catch (exception) {
    console.log('Error during save custom prompt from chat request');
    return {
      success: false,
      error: 'exception',
      message: 'An error occurred while saving the prompt',
    };
  }
}
